
export enum TypeFactureClientEnum {
  FACTURE_CLIENT_PRESTATION = 'FACTURE_CLIENT_PRESTATION',
  FACTURE_CLIENT_FAMILLE_FACTURATION = 'FACTURE_CLIENT_FAMILLE_FACTURATION'
}
